// extracted by mini-css-extract-plugin
module.exports = {"encouragement-count-box":"encouragement-count-box___3xYmr","type":"type___2mr-q","count":"count___qwC28"};